<div class="navbar-custom px-sm-2">
  <div class="topbar container-fluid pe-0 pe-sm-2">
    <div class="d-flex align-items-center">
      <div class="logo-topbar ps-0 pe-2 pe-sm-3">
        <a routerLink="/" class="logo-dark">
          <img
            *ngIf="companyInfo?.logo"
            [src]="companyInfo.logo"
            [alt]="companyInfo.companyName + 'logo'"
          />
          <span *ngIf="!companyInfo?.logo && companyInfo?.companyName">
            {{ companyInfo.companyName }}
          </span>
        </a>
      </div>

      <a routerLink="/dashboard" class="compliance-link text-dark ps-2 ps-sm-3">
        Driver Portal
      </a>
    </div>

    <ul class="topbar-menu d-flex align-items-center p-0">
      <li class="d-inline-block">
        <a routerLink="/" class="nav-link home-link px-2">
          <i class="mdi mdi-home-outline"></i>
        </a>
      </li>

      <li
        class="dropdown user-menu"
        #profileDropdown="ngbDropdown"
        ngbDropdown
        placement="bottom"
        [autoClose]="profileMenuAutoClose$ | async"
      >
        <a
          class="nav-link dropdown-toggle arrow-none nav-user px-2"
          ngbDropdownAnchor
          role="button"
          aria-haspopup="false"
          aria-expanded="false"
          (click)="profileDropdown.toggle()"
        >
          <app-avatar class="account-user-avatar"></app-avatar>
          <span class="account-user-name d-none d-sm-inline-block">
            {{ username }}
          </span>
        </a>

        <div
          class="dropdown-menu dropdown-menu-end dropdown-menu-animated"
          ngbDropdownMenu
        >
          <a
            routerLink="/myaccount"
            class="dropdown-item notify-item"
            tourAnchor="myaccount"
            ngbDropdownItem
          >
            <i class="mdi mdi-account-circle me-1"></i>
            <span>My Account</span>
          </a>

          <a
            class="dropdown-item notify-item"
            ngbDropdownItem
            (click)="install()"
            *ngIf="pwa.promptEvent"
          >
            <i class="mdi mdi-home me-1"></i>
            <span>Add to Home</span>
          </a>

          <a
            class="dropdown-item notify-item"
            ngbDropdownItem
            (click)="showQuickTour()"
            *ngIf="auth.driverID && auth.driverStatus === 'Y' && isDashboard"
          >
            <i class="mdi mdi-chat-processing me-1"></i>
            <span>Quick Tour</span>
          </a>

          <a
            class="dropdown-item notify-item"
            ngbDropdownItem
            (click)="openHelp()"
          >
            <i class="mdi mdi-message-draw me-1"></i>
            <span>Help</span>
          </a>

          <a
            href="javascript:void(0);"
            class="dropdown-item notify-item"
            ngbDropdownItem
            (click)="logout()"
          >
            <i class="mdi mdi-logout me-1"></i>
            <span>Logout</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</div>
